"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cached_promise_1 = __importDefault(require("../utils/decorators/cached-promise"));
var Team_1 = __importDefault(require("./Entity/Team"));
var TeamApi = /** @class */ (function () {
    function TeamApi(session) {
        this.teamEntity = new Team_1.default(session);
    }
    TeamApi.prototype.get = function (id) {
        return this.teamEntity.get(id);
    };
    TeamApi.prototype.forceGet = function (id) {
        return this.teamEntity.service.get(id);
    };
    TeamApi.prototype.getAll = function () {
        return this.teamEntity.getAll();
    };
    TeamApi.prototype.update = function (id, team) {
        return this.teamEntity.updateTeam(id, team);
    };
    TeamApi.prototype.create = function (team) {
        return this.teamEntity.createTeam(team);
    };
    TeamApi.prototype.byMerchantId = function (merchantId) {
        return this.teamEntity.byMerchantId(merchantId);
    };
    __decorate([
        cached_promise_1.default
    ], TeamApi.prototype, "getAll", null);
    return TeamApi;
}());
exports.default = TeamApi;
//# sourceMappingURL=TeamApi.js.map